import React, { useState } from 'react';
import { CardManagement } from './CardManagement';
import { EyeIcon, EyeOffIcon, LockIcon, UnlockIcon, PlusIcon, CreditCardIcon } from 'lucide-react';
export function CardView() {
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [isCardFrozen, setIsCardFrozen] = useState(false);
  const [showCambridgeCardDetails, setShowCambridgeCardDetails] = useState(false);
  const [isCambridgeCardFrozen, setIsCambridgeCardFrozen] = useState(false);
  return <div className="space-y-6" data-id="element-189">
      <h1 className="text-2xl font-bold text-text-primary" data-id="element-190">Your Cards</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-191">
        <div className="bg-card rounded-xl shadow-sm p-6 space-y-6" data-id="element-192">
          <CardManagement cardNumber="4539 1234 5678 9012" expiryDate="05/25" cvv="123" data-id="element-193" />
          <div className="grid grid-cols-2 gap-3" data-id="element-194">
            <button onClick={() => setShowCardDetails(!showCardDetails)} className="flex items-center justify-center space-x-2 p-3 border border-gray-200 rounded-lg hover:bg-gray-50" data-id="element-195">
              {showCardDetails ? <>
                  <EyeOffIcon className="w-5 h-5 text-gray-600" data-id="element-196" />
                  <span className="text-sm font-medium" data-id="element-197">Hide Details</span>
                </> : <>
                  <EyeIcon className="w-5 h-5 text-gray-600" data-id="element-198" />
                  <span className="text-sm font-medium" data-id="element-199">Show Details</span>
                </>}
            </button>
            <button onClick={() => setIsCardFrozen(!isCardFrozen)} className={`flex items-center justify-center space-x-2 p-3 rounded-lg ${isCardFrozen ? 'bg-red-100 text-red-600 border border-red-200' : 'border border-gray-200 hover:bg-gray-50'}`} data-id="element-200">
              {isCardFrozen ? <>
                  <LockIcon className="w-5 h-5" data-id="element-201" />
                  <span className="text-sm font-medium" data-id="element-202">Frozen</span>
                </> : <>
                  <UnlockIcon className="w-5 h-5 text-gray-600" data-id="element-203" />
                  <span className="text-sm font-medium" data-id="element-204">Freeze Card</span>
                </>}
            </button>
          </div>
        </div>
        {/* Cambridge University Card */}
        <div className="bg-card rounded-xl shadow-sm p-6 space-y-6" data-id="element-205">
          <div className="flex flex-col items-center space-y-4" data-id="element-206">
            <div className="relative w-full flex justify-center" data-id="element-207">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q9kXG6izQFvfVQrq4wWd6Y/53697a95-dadf-4e56-bfca-d3336b4e2b78-removebg-preview.png" alt="Cambridge University Cauri Card" className={`w-full max-w-xs h-auto rounded-lg shadow-sm transition-all duration-300 ${isCambridgeCardFrozen ? 'opacity-85 contrast-75 brightness-110 saturate-50' : ''}`} data-id="element-208" />
              {isCambridgeCardFrozen && <div className="absolute inset-0 bg-gradient-to-br from-blue-100/60 to-blue-200/60 rounded-lg backdrop-blur-[2px] max-w-xs mx-auto" data-id="element-209">
                  <div className="absolute inset-0 bg-white/20 rounded-lg" data-id="element-210"></div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-12" data-id="element-211">
                    <div className="text-blue-600 font-bold text-xl border-4 border-blue-500 px-4 py-1 rounded-md bg-blue-100/80 backdrop-blur-sm" data-id="element-212">
                      FROZEN
                    </div>
                  </div>
                </div>}
            </div>
            {showCambridgeCardDetails && <div className="w-full space-y-2" data-id="element-213">
                <div className="flex justify-between" data-id="element-214">
                  <span className="text-sm text-text-secondary" data-id="element-215">
                    Card Number
                  </span>
                  <span className="text-sm font-mono" data-id="element-216">5678 9012 3456 7890</span>
                </div>
                <div className="flex justify-between" data-id="element-217">
                  <span className="text-sm text-text-secondary" data-id="element-218">
                    Expiry Date
                  </span>
                  <span className="text-sm font-mono" data-id="element-219">09/27</span>
                </div>
                <div className="flex justify-between" data-id="element-220">
                  <span className="text-sm text-text-secondary" data-id="element-221">CVV</span>
                  <span className="text-sm font-mono" data-id="element-222">456</span>
                </div>
              </div>}
          </div>
          <div className="grid grid-cols-2 gap-3" data-id="element-223">
            <button onClick={() => setShowCambridgeCardDetails(!showCambridgeCardDetails)} className="flex items-center justify-center space-x-2 p-3 border border-gray-200 rounded-lg hover:bg-gray-50" data-id="element-224">
              {showCambridgeCardDetails ? <>
                  <EyeOffIcon className="w-5 h-5 text-gray-600" data-id="element-225" />
                  <span className="text-sm font-medium" data-id="element-226">Hide Details</span>
                </> : <>
                  <EyeIcon className="w-5 h-5 text-gray-600" data-id="element-227" />
                  <span className="text-sm font-medium" data-id="element-228">Show Details</span>
                </>}
            </button>
            <button onClick={() => setIsCambridgeCardFrozen(!isCambridgeCardFrozen)} className={`flex items-center justify-center space-x-2 p-3 rounded-lg ${isCambridgeCardFrozen ? 'bg-red-100 text-red-600 border border-red-200' : 'border border-gray-200 hover:bg-gray-50'}`} data-id="element-229">
              {isCambridgeCardFrozen ? <>
                  <LockIcon className="w-5 h-5" data-id="element-230" />
                  <span className="text-sm font-medium" data-id="element-231">Frozen</span>
                </> : <>
                  <UnlockIcon className="w-5 h-5 text-gray-600" data-id="element-232" />
                  <span className="text-sm font-medium" data-id="element-233">Freeze Card</span>
                </>}
            </button>
          </div>
        </div>
        <div className="bg-card rounded-xl shadow-sm p-6 border border-dashed border-gray-300 flex flex-col items-center justify-center text-center space-y-3" data-id="element-234">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-235">
            <PlusIcon className="w-8 h-8 text-primary" data-id="element-236" />
          </div>
          <h3 className="text-lg font-medium text-text-primary" data-id="element-237">
            Add New Card
          </h3>
          <p className="text-sm text-text-secondary max-w-xs" data-id="element-238">
            Add a virtual card for online shopping or request a physical card.
          </p>
          <button className="mt-2 bg-primary text-white py-2 px-4 rounded-lg text-sm font-medium" data-id="element-239">
            Order New Card
          </button>
        </div>
      </div>
      <div className="bg-card rounded-xl shadow-sm" data-id="element-240">
        <div className="p-4 border-b border-gray-100" data-id="element-241">
          <h2 className="text-lg font-semibold text-text-primary" data-id="element-242">
            Card Transactions
          </h2>
        </div>
        <div className="p-6 text-center" data-id="element-243">
          <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-3" data-id="element-244">
            <CreditCardIcon className="w-8 h-8 text-gray-400" data-id="element-245" />
          </div>
          <h3 className="text-lg font-medium text-text-primary" data-id="element-246">
            No recent transactions
          </h3>
          <p className="text-sm text-text-secondary mt-1 max-w-xs mx-auto" data-id="element-247">
            Your recent card transactions will appear here once you start using
            your card.
          </p>
        </div>
      </div>
    </div>;
}